import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"
import _imports_0 from '../../assets/image/vipImg/icon_tab_vip@2x.png'


const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "explain mt_20" }
const _hoisted_5 = { class: "content-c mt_30" }
const _hoisted_6 = { style: {"padding":"0 !important"} }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_8 = { class: "text" }

import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
import { useRtfix } from '@/store'
import { memberChangeFlag, UpmemberChangeFlag } from '@/apis/membership'
import { t } from '@/plugins/i18n'
import PwdSecurity from '../PwdSecurity/PwdSecurity1.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const dialogVisible = ref(false) // 弹窗显示
const router = useRouter()
const membership = store.getters.membership
const isSub = store.getters.isSub
const pwdSecurity1 = ref()
const effectList = ref([ // 功能列表
  {
    id: 1,
    text: t('能够在中国找到丰富的供应商')
  },
  {
    id: 2,
    text: t('按照日本质量标准进行检验（隶属于日本公司）')
  },
  {
    id: 3,
    text: t('最低国际运费保证，可运往23个国家/地区')
  },
  {
    id: 4,
    text: t('可靠的支持和即时的客户服务')
  }
])

onMounted(() => {
  getMmemberChangeFlag()
})

// 获取会员状态提醒
const getMmemberChangeFlag = () => {
  memberChangeFlag().then((res: any) => {
    if (res.code === '0') {
      if (res.data === false && membership.templateLevel === 0) {
        dialogVisible.value = true
        return
      }
    }
    pwdSecurity1.value.openModal()
  })
}

const closeModal = (type: number) => {
  UpmemberChangeFlag().then((res: any) => {
    if (res.code === '0') {
      dialogVisible.value = false
      if (type === 2) router.push(useRtfix('VipLevel'))
      // 获取是否修改密码状态，建议用户修改密码
      if (type === 1) pwdSecurity1.value.openModal()
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", null, [
      _createVNode(_component_el_dialog, {
        "z-index": 100,
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogVisible).value = $event)),
        width: "600px",
        "custom-class": "membereExpire",
        "close-on-click-modal": false,
        onClose: _cache[2] || (_cache[2] = ($event: any) => (closeModal(1)))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('您的会员已到期！')), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, _toDisplayString(_unref(t)('您当前的会员已到期，为了不影响正常下单和使用，请及时开通哦！（不影响历史订单集账户余额充值）')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(effectList.value, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: item.id,
                    class: "list flex ter"
                  }, [
                    _hoisted_7,
                    _createElementVNode("p", _hoisted_8, _toDisplayString(item.text), 1)
                  ]))
                }), 128))
              ])
            ]),
            _createVNode(_component_el_button, {
              class: "btn mt_25",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal(2)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(isSub) ? _unref(t)('查看会员') : _unref(t)('开通会员')), 1)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(PwdSecurity, {
      ref: (_value, _refs) => {
        _refs['pwdSecurity1'] = _value
        pwdSecurity1.value = _value
      }
    }, null, 512)
  ], 64))
}
}

})